import { toast } from 'sonner'
import { useConfirm } from '@/components/common/ConfirmDialog'
import { useDeleteTrackValue, useReorderTrackValues } from '@/features/contract/statuses/hooks'
import type { StatusTrackValue } from '@/features/contract/statuses/types'
import { SortableList } from '@/components/common/SortableList'
import { formatError } from './formatError'

export function ValuesList({ trackId, values, onEdit }: {
  trackId: number
  values: StatusTrackValue[]
  onEdit: (v: StatusTrackValue) => void
}) {
  const confirm = useConfirm()
  const del = useDeleteTrackValue()
  const reorder = useReorderTrackValues(trackId)

  if (values.length === 0) {
    return <p className="text-center text-slate-500 py-8 text-sm">Brak wartości - dodaj pierwszą.</p>
  }

  return (
    <SortableList
      items={values}
      getId={v => v.id}
      onReorder={ids => reorder.mutate(ids.map(Number))}
      renderItem={v => (
        <div className="flex items-center gap-3">
          <span className="font-mono text-xs text-slate-500 w-32 shrink-0">{v.code}</span>
          <span className="flex-1 truncate">{v.labelPl}</span>
          <span className={`text-[10px] px-1.5 py-0.5 rounded ${v.isActive ? 'bg-emerald-50 text-emerald-700' : 'bg-slate-100 text-slate-500'}`}>
            {v.isActive ? 'aktywne' : 'nieaktywne'}
          </span>
          <button onClick={() => onEdit(v)} className="text-xs text-slate-600 px-1 hover:text-sky-700">Edytuj</button>
          <button
            onClick={async () => {
              const ok = await confirm({
                title: `Usunąć wartość ${v.code}?`,
                description: 'Operacja jest nieodwracalna.',
                confirmLabel: 'Usuń',
                variant: 'destructive',
              })
              if (ok) del.mutate({ trackId, valueId: v.id }, { onError: e => toast.error(formatError(e)) })
            }}
            className="text-xs text-red-600 px-1"
          >Usuń</button>
        </div>
      )}
    />
  )
}
